<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="dismiss('back')">
                <ion-icon name="arrow-back" color="primary"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>{{ 'SETTINGS' | translate }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-row class="settings" *ngFor="let counter of counters; let i = index;">
        <ion-col ize="9" class="setting-item">
            <p>{{ counter.name | translate }}</p>
        </ion-col>
        <ion-col size="3" class="calculation">
            <button class="btn" clear (click)="counter.value = counter.value - 1; update()">
                <ion-icon name="remove-circle" ></ion-icon>
            </button>
            <span>{{ counter.value }}</span>
            <button class="btn" clear (click)="counter.value = counter.value +  1; update()">
                <ion-icon name="add-circle" ></ion-icon>
            </button>
        </ion-col>
    </ion-row>
</ion-content>